<template>
	<div>
		<div class="spinner-border" v-if="loader" style="margin:auto;display:block;margin-top:60px"/>
		<div class = "col-sm-12 row" v-else>

			<div style = "width:100%;" class = "">
				<div style = "border-bottom: 2px solid #115E67;margin-bottom: 10px;font-size: 20px;padding: 5px 0px 0px 5px;"><h4 style = "margin-bottom:0px;">YTD Shipped Cogs</h4></div>
				<div v-if = "cogs.length" style = "padding-top: 10px;padding-bottom: 15px;border: 1px solid #ced4da;max-height:500px;overflow: scroll;" >
					<table class="table">
						<thead>
							<tr style = "">
								<th>Asin</th>
								<th>Title</th>
								<th>Shipped Cogs</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for = "(element,index) in cogs" :key = "index">
								<td>{{element.asin}}</td>
								<td>{{element.producttitle}}</td>
								<td>{{element.shippedcogs}}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-else><p style = "padding-left:10px;padding-bottom:15px">No Shipped Cogs</p></div>
			</div>

			
			<!-- <script type='application/javascript' src='https://us-east-1.online.tableau.com/javascripts/api/viz_v1.js'></script>
				<div class='tableauPlaceholder' style='width: 1366px; height: 818px;'>
					<object class='tableauViz' width='1366' height='818' style='display:none;'>
						<param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' />
						<param name='embed_code_version' value='3' />
						<param name='site_root' value='t/globaloverview' />
						<param name='name' value='NewAMS_15743716531840/BudgetDashboard' />
						<param name='tabs' value='yes' />
						<param name='toolbar' value='yes' />
						<param name='showAppBanner' value='false' />
				</object>
			</div> -->



		</div>
	</div>
</template>

<script>
export default {
	name: "Tables",
	data() {
		return{
			cogs:[],
			loader: false,
		}
	},
	props:["vendorId", "profile_brand_name"],
	mounted(){
		this.getCogsList();
		// Tableau
		this.profile_brand_name &&  document.querySelector('.tableauPlaceholder iframe').setAttribute('src', document.querySelector('.tableauPlaceholder iframe').getAttribute('src') + `&Profile Brand Name=${this.profile_brand_name}`)
	},
	methods:{
		getCogsList(data){

			let payload = {
				vendor_id :this.vendorId
			}
			let vm = this;
			this.$store.dispatch("sales/getCogsList", payload).then((res) => {
				if(res){
					vm.cogs = res
				}
			})
		},
	}
}
</script>
